import RequestAuthDataTableInput_vue_vue_type_script_setup_true_lang_default from "./RequestAuthDataTableInput.vue_vue_type_script_setup_true_lang.js";
//#region src/v2/blocks/scalar-auth-selector-block/components/RequestAuthDataTableInput.vue
var RequestAuthDataTableInput_default = RequestAuthDataTableInput_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { RequestAuthDataTableInput_default as default };

//# sourceMappingURL=RequestAuthDataTableInput.vue.js.map